import TextField, { TextFieldProps } from '@mui/material/TextField';
import { Controller, FieldValues, UseControllerProps } from 'react-hook-form';

type ConnectedTextFieldProps<TFieldValues extends FieldValues> = 
    Omit<TextFieldProps, 'variant'> &
    UseControllerProps<TFieldValues> & {
        prompt?: string;
    }

function ConnectedTextField<TFieldValues extends FieldValues>({ 
    control, 
    name, 
    rules,
    ...rest 
}: ConnectedTextFieldProps<TFieldValues>) {
    return (
        <Controller 
            name={ name }
            control={ control }
            rules={{ required: rest.required ? 'Required' : false, ...rules }}
            render={ ({ field: { ref, value, ...field }, fieldState }) => (
                <TextField 
                    { ...field }
                    error={ Boolean(fieldState.error?.message) }
                    helperText={ fieldState.error?.message }
                    inputRef={ ref }
                    value={ value ?? '' }
                    { ...rest }
                />
            ) }
        />
    );
}

export default ConnectedTextField;
